const defaultSeverityOrder = { error: 3, warning: 2, info: 1 };

export const toArray = (alerts) => {
  if (!alerts) return [];
  if (Array.isArray(alerts)) return alerts;
  if (typeof alerts === 'object') return Object.values(alerts);
  return [];
};

export const defaultVisibility = (alertItem) => alertItem && alertItem.show === true;

const severityRank = (severityOrder, severity) => {
  const order = severityOrder || defaultSeverityOrder;
  const key = (severity || 'info');
  return typeof order[key] === 'number' ? order[key] : 0;
};

export default function selectTopAlert(inputAlerts, config = {}) {
  const {
    visibilityPredicate = defaultVisibility,
    severityOrder = defaultSeverityOrder,
  } = config;

  const items = toArray(inputAlerts).filter(visibilityPredicate)

  if (!items.length) return null;

  items.sort((leftAlert, rightAlert) => {
    const severityDifference = severityRank(severityOrder, rightAlert.severity) - severityRank(severityOrder, leftAlert.severity);
    if (severityDifference !== 0) return severityDifference;

    const priorityDifference = (rightAlert.priority ?? 0) - (leftAlert.priority ?? 0);
    if (priorityDifference !== 0) return priorityDifference;

    return (rightAlert.lastUpdated ?? 0) - (leftAlert.lastUpdated ?? 0);
  });

  return items[0] || null;
}


